import React, { useState, useEffect } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';

import graph from './graph';
import { useSelector } from 'react-redux';
import { isEmptyObject } from 'helpers/formatObject';

import { Avatar, Card, CardContent, CardHeader, IconButton, Stack, TextField, Typography } from '@mui/material';
import { CircularProgress } from '@mui/material';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import { toast } from 'react-toastify';

export default function Content({ model }) {
  const {
    id,
    shop,
    status,
    customer,
    call_me,
    fast_send,
    total_cost,
    created_at,
    demand_time,
    delivery_time,
    tracking_code,
  } = model;
  const [result, setResult] = useState({});
  const { userToken } = useSelector((state) => state.auth);
  const [description, setDescription] = useState();

  const handleChange = (e) => {
    setDescription(e.target.value);
  };

  const [getData, { loading }] = useLazyQuery(graph.get.query, {
    variables: {
      ids: id,
      for_admin: 1,
    },
    context: {
      serviceName: graph.get.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const [formUpdate, { loading: updating }] = useMutation(graph.update.query, {
    context: {
      serviceName: graph.update.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const fetchData = async () => {
    try {
      const { data } = await getData();
      if (!isEmptyObject(data)) {
        const res = data[graph.get.name]?.data[0];
        setResult(res);
        setDescription(res.sys_description);
      }
    } catch (error) {}
  };

  const onSubmit = async (formdata) => {
    try {
      const { data } = await formUpdate({
        variables: {
          ids: id,
          ...formdata,
        },
      });
      if (data) {
        data[graph.update.name]?.messages.map((message) => toast.success(String(message)));
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return (
      <Stack justifyContent="center" alignItems="center" height="100%" rowGap={2}>
        <CircularProgress size={26} />
        <Typography variant="caption">در حال بارگذاری...</Typography>
      </Stack>
    );
  }

  return (
    <Stack justifyContent="space-between" height="100%" rowGap={1}>
      <Stack rowGap={1} pt={2}>
        <Card>
          <CardHeader
            avatar={
              <Avatar sx={{ bgcolor: 'warning.lighter' }}>
                <AccountCircleRoundedIcon fontSize="small" color="warning" />
              </Avatar>
            }
            title="توضیحات کاربر"
            sx={{ p: 1 }}
          />
          <CardContent sx={{ p: 1 }}>
            <Typography>{result?.description || '-'}</Typography>
          </CardContent>
        </Card>
        <Card>
          <CardHeader
            avatar={
              <Avatar sx={{ bgcolor: 'error.lighter' }}>
                <ErrorOutlineRoundedIcon fontSize="small" color="error" />
              </Avatar>
            }
            title="توضیحات سیستم"
            sx={{ p: 1 }}
            action={
              <Stack columnGap={0.5} direction="row" alignItems="center" justifyContent="flex-end">
                <IconButton
                  sx={{ bgcolor: 'info.lighter' }}
                  variant="contained"
                  size="medium"
                  color="primary"
                  onClick={() => onSubmit({ sys_description: description })}
                >
                  {updating ? <CircularProgress size={25} /> : <SaveRoundedIcon fontSize="small" />}
                </IconButton>
              </Stack>
            }
          />
          <CardContent sx={{ p: 1 }}>
            <TextField
              autoFocus
              fullWidth
              rows={10}
              multiline
              id="description"
              type="text"
              label="توضیحات سیستم"
              placeholder="برای مثال: یخ خشک در کنار بستنی فراموش نشود!"
              onChange={handleChange}
              value={description}
            />
          </CardContent>
        </Card>
      </Stack>
    </Stack>
  );
}
